'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = HotelInfoPanel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _defaultClasses = require('../../../../../constants/defaultClasses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _renderHotelData = function _renderHotelData(components, hotelProperty) {
  return _react2.default.createElement(
    'table',
    null,
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.PickupTitleLabel)) },
            hotelProperty.longName
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.HotelInfoValueLabel)) },
            hotelProperty.address
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.HotelInfoValueLabel)) },
            hotelProperty.location.cityName + ', ' + hotelProperty.location.countryName
          )
        )
      )
    )
  );
};

var _renderCheckData = function _renderCheckData(components, hotelProperty) {
  return _react2.default.createElement(
    'table',
    null,
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CheckinTitleLabel)) },
            'Check-In:'
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CheckinValueLabel)) },
            dateTimeHelper.getDate(hotelProperty.checkInDate)
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CheckoutTitleLabel)) },
            'Check-Out:'
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.CheckinValueLabel)) },
            dateTimeHelper.getDate(hotelProperty.checkOutDate)
          )
        )
      )
    )
  );
};

function HotelInfoPanel(props) {
  var option = props.option;
  var components = props.components;
  var hotelProperty = option.hotelProperty;


  return _react2.default.createElement(
    'table',
    { style: _defaultClasses.mainTableClass, 'data-component': 'HotelHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.HotelContainer)) },
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.HotelContainer), { padding: '10px' }) },
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { textAlign: 'center' } },
                  _react2.default.createElement('img', { src: 'https://goprivate.wspan.com/Scripts/us/GNG/ImagesGNG/hotel.png', alt: 'logo', style: { width: '50px', height: '50px' } })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.HotelContainer), { padding: '10px' }) },
          _renderHotelData(components, hotelProperty)
        ),
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.HotelContainer), { padding: '10px' }) },
          _renderCheckData(components, hotelProperty)
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Passive/HotelInfoPanel.jsx
// module id = 1531
// module chunks = 0